// plugins/counselorList.js
export default defineNuxtPlugin(async (nuxtApp) => {
  if (!import.meta.client) return;

  const { fetchCslList } = useCounselorList();
  const { fetchMyLikes } = useMyLikes();

  fetchCslList();
  
  // Vue 앱이 마운트된 후 fetchMyLikes 실행
  nuxtApp.hook("app:mounted", () => {
    fetchMyLikes();
  });
});